import React from 'react';
import LocalModal from 'components/base/local-modal';
import { BankTransfer, ENUM_API_ENV } from '@cokitchen/cokitchen-payments';
import { toast } from 'react-toastify';

import { handleApiError } from 'utils/functions';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  orderId: string;
};

const paymentModuleEnv = process.env.REACT_APP_FC_PAYMENT_MODULE_ENV as ENUM_API_ENV;

const TransferPaymentModal = ({ isOpen, onRequestClose, orderId }: Props) => {
  const navigate = useNavigate();
  return (
    <LocalModal isOpen={isOpen} onRequestClose={onRequestClose}>
      <main className='w-full bg-white rounded-2xl shadow-lg'>
        <BankTransfer
          onCountDownComplete={() => {
            //
          }}
          orderId={orderId}
          onPaymentSuccess={() => {
            toast(<ToastMessage type='success' message='✅ Payment successful!' />);
            setTimeout(() => navigate('/orders'), 500);
          }}
          onPaymentError={(error: unknown) => handleApiError(error)}
          env={paymentModuleEnv}
        />
      </main>
    </LocalModal>
  );
};

export default TransferPaymentModal;
